import { render, staticRenderFns } from "./S5.vue?vue&type=template&id=84602954&scoped=true&"
import script from "./S5.vue?vue&type=script&lang=js&"
export * from "./S5.vue?vue&type=script&lang=js&"
import style0 from "./S5.vue?vue&type=style&index=0&id=84602954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84602954",
  null
  
)

export default component.exports